import { Button } from '@mui/material';
import { useStyles } from './styles';
import { INotificationButtonProps } from './interfaces';

const NotificationButton = ({
  children,
  onClick,
  color,
  primary = false,
}: INotificationButtonProps) => {
  const classes = useStyles(color, primary);

  return (
    <Button
      sx={classes.root}
      variant={primary ? 'contained' : 'outlined'}
      disableElevation
      disableRipple
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default NotificationButton;
